module.exports = __webpack_public_path__ + "static/media/H.Eliyev.bddd4937.jpg";